var _rect, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEnrich(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 23,
    viewBox: "0 0 24 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 5.79297,
    width: 24,
    height: 16.9655,
    fill: "url(#pattern0_1594_370)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.64648 5C3.64648 2.65279 5.54927 0.75 7.89648 0.75H16.1034C18.4506 0.75 20.3534 2.65279 20.3534 5V13.2069C20.3534 15.5541 18.4506 17.4569 16.1034 17.4569H7.89648C5.54927 17.4569 3.64648 15.5541 3.64648 13.2069V5Z",
    stroke: "#001A54",
    strokeWidth: 1.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_1594_370",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_1594_370",
    transform: "scale(0.0111111 0.0157182)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_1594_370",
    width: 90,
    height: 90,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAACXBIWXMAAAsTAAALEwEAmpwYAAACFklEQVR4nO2dT4vTQABHRw9WwaunGdhLDpl+WUUFRUS/gwf/fI9c5ncR/AB6WGS9RWZXpbruNp22KfzyHuTSNMnw+pq2DExDAIATMoZwdwzhDi/CkfiS0oPSx9clxx8lxwvl9Orz2dl9hB8Qdd1KfXqvnMbNrfTxA7IPxLBe3ys5vftX8h/ZOX5C9pElC9nHL1nInl+yKHs+yUL2fJKRPaNkZM8oeUP2R776bfkx8td22/4Jxy5e9jCh5N9V3rR/l3OEJTLsKOim57ScazEMDWJuE916TmuGRiHbRO9z7uV+8HXd6tqxE0Tvew0blOOzVgFTRU+VXfr0JLjOjJQ+fW+tbBfRk2T36dxypmasoq9mRpreyruK3ia7jqWOKTiiHN+23i9bRG+ZnXkTXBnWjx5W2Zdl9+m85PR46odSq+jLY7tuVe/JV9eMF1VyHUtwZ2y4N+4jevO6lvflQ6IDiIYJIHomRNGItkIUjWgrRNGItkIUjWgrRNGItkIUjWgrRNGItkIUjWgrRNGItkIUjWgrRNGItkIUjWgrRNGItkIUjWgrRNGItkIUjWgrRNGItkIUjWgrRNGItkIUjWgrRNGItkIUjWgrRNGItkIUjWgrRNGItkIUjWgrRNGItkIUjWgrRNHzUPr47T8r5n6d6fLLQTk+v74kcnx66nFZ/hWq+vSyrqr+a3tRHzv1uGwZWZoYIJyen2J6ZtCotptrAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnrich);
export default __webpack_public_path__ + "static/media/enrich.3459c23d3d2ddd65a704e12f11fe4876.svg";
export { ForwardRef as ReactComponent };